import { useApi } from '@omnipresentgroup/api';
import { useCallback } from 'react';

import { API_PATH, API_UPLOAD_PATH, COMPENSATION_API_BASE } from '../constants';

export const useExpensesUpload = () => {
  const { POST } = useApi();
  const uploadExpensesFile = useCallback(
    ({ file }: { file: File }) => {
      return POST({
        path: `${COMPENSATION_API_BASE}/${API_PATH}/${API_UPLOAD_PATH}`,
        body: { file },
        asFormData: true,
      });
    },
    [POST],
  );

  return {
    uploadExpensesFile,
  };
};
